import { createContext, useCallback, useMemo, useReducer } from 'react';

const VideoContext = createContext({
    hideVideo: () => {},
    showVideo: () => {},
    video: { show: false, id: null },
});

const actionTypes = {
    TOGGLE: 'TOGGLE_VIDEO',
};

const reducer = (state, action) => {
    switch (action.type) {
        case actionTypes.TOGGLE:
            return {
                ...state,
                video: action.payload,
            };
        default:
            return state;
    }
};

export const VideoProvider = ({ children }) => {
    const [state, dispatch] = useReducer(reducer, {
        video: { show: false, id: null },
    });

    const hideVideo = useCallback(() => {
        dispatch({
            type: actionTypes.TOGGLE,
            payload: { show: false, id: null },
        });
    }, []);

    const showVideo = useCallback((id) => {
        dispatch({
            type: actionTypes.TOGGLE,
            payload: { show: true, id: id || 'SZEflIVnhH8' },
        });
    }, []);

    const value = useMemo(
        () => ({
            video: state.video,
            hideVideo,
            showVideo,
        }),
        [hideVideo, showVideo, state.video]
    );

    return <VideoContext.Provider value={value}>{children}</VideoContext.Provider>;
};

export default VideoContext;
